import httpClient from "../../../../../shared/api/httpClient";
import { qs } from "../../../../../shared/api/qs";

export const STOCK_INVENTORY_PAGE_SIZE = 30;

export const getStockInventory = async ({
  page = 1,
  type,
  sector,
  categoryId,
  ingredientId,
  search,
  signal,
} = {}) => {
  const query = qs({
    page,
    limit: STOCK_INVENTORY_PAGE_SIZE,
    type,
    sector,
    categoryId,
    ingredientId,
    search,
  });
  return httpClient.get(`/stock/inventory${query}`, { signal });
};
